/*  ==========================================================================
		PHP Variables
		========================================================================== */

// If you need to access variables such as template url, or AJAX url within this file you can use the variable php_variables.template_url or php_variables.ajax_url
// which has been passed in via enqueue-scripts.php

/*  ==========================================================================
		Grid variables - needed for gridcarousel__init
		========================================================================== */

// NOTE: If your updating this make sure to also update the SASS Variables in _variables.scss
const gridSizes = {
  sm: "550",
  md: "700",
  lg: "1000",
  xl: "1200",
  ws: "1400",
  xw: "1600",
  xxw: "1800",
  xxxw: "2000"
};

/*  ==========================================================================
      DOM element variables 
      ========================================================================== */

const body = document.querySelector("body");

/*  ==========================================================================
		Device Detection - Check if is mobile or ipad
		========================================================================== */

let isMobile = false; // initiate as false
const isTouchDevice = !!("ontouchstart" in window);

if (/Android|webOS|iPhone|iPod|BlackBerry|IEMobile|Opera Mini/i.test(window.navigator.userAgent)) {
  isMobile = true;
}

/*  ==========================================================================
		Create a 100vh css variable
		========================================================================== */

const setViewHeight = function () {
  // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
  let vh = window.innerHeight;
  // Then we set the value in the --vh custom property to the root of the document
  document.documentElement.style.setProperty("--vh", `${vh}px`);
};

setViewHeight();

window.addEventListener("resize", () => {
  setViewHeight();
});

/*  ==========================================================================
		GENERAL - add linklines to links
		========================================================================== */

const linksInit = function () {
  const links = document.querySelectorAll(
    "a:not(.noline):not(.line-added):not(.overlay__link):not(.filter__btn):not(.pill)"
  );
  links.forEach(function (el) {
    if (el.closest(".noline")) {
      return;
    }

    const icon = el.querySelector(".fa, .fa-solid, .fa-regular, .fa-light, .fa-thin, .fa-brands");

    if (el.querySelector("img") < 1) {
      const linkHTML = "<span class='linkline'>" + el.textContent + "</span>";
      el.innerHTML = linkHTML;
      el.classList.add("line-added");
      if (icon) {
        const iconHTML = icon;
        if (icon.classList.contains("fa--left")) {
          el.querySelector(".linkline").before(icon);
        } else {
          el.querySelector(".linkline").after(icon);
        }
      }
    }
  });
  //return true;
}; // linksInit();
linksInit();

/*  ==========================================================================
    GENERAL - accordion
    ========================================================================== */

const accordionQuestions = document.querySelectorAll(".accordion__question");

const accordionInit = function (accordionItems) {
  if (!accordionItems) {
    return;
  }

  accordionItems.forEach(item =>
    item.addEventListener("click", function () {
      item.closest(".accordion__item").classList.toggle("accordion__item--open");
      this.classList.toggle("active");
      var panel = this.nextElementSibling;
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null;
      } else {
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    })
  );
  window.addEventListener("resize", function () {
    accordionItems.forEach(function (item) {
      if (item.closest(".accordion__item").classList.contains("accordion__item--open")) {
        let panel = item.nextElementSibling;
        panel.style.maxHeight = panel.scrollHeight + "px";
      }
    });
  });
}; // accordionInit();
accordionInit(accordionQuestions);

/*  ==========================================================================
    GENERAL - sidebar links
    ========================================================================== */

const sidebarLinks = document.querySelectorAll(".sidebar__anchor");

const sidebarLinksInit = function (sidebarLinks) {
  if (!sidebarLinks) {
    return;
  }

  sidebarLinks.forEach(item =>
    item.querySelector(".sidebar__anchor__header").addEventListener("click", function () {
      item.classList.toggle("sidebar__anchor--closed");
    })
  );
}; // sidebarLinksInit();
sidebarLinksInit(sidebarLinks);

/*  ==========================================================================
    GENERAL - LazyLoad - Enable Lazy load for images
    ========================================================================== */

// Lazy load images (or everything with .lazy)
const lazyLoadInstance = new LazyLoad();

/*  ==========================================================================
    GENERAL - Initiate plyr (custom video controls)

    This is automatically disabled on builds, to enable uncomment the JS here
    and then go to functions / enqueue-scripts and enqueue-styles to uncomment and enable the css and JS 

    ========================================================================== */

// const plyrsInit = function () {
//   const plyrs = document.querySelectorAll(".mediavideo:not(.mediavideo--autoplay)");

//   if (!plyrs) {
//     return;
//   }

//   plyrs.forEach(function (el) {
//     let plyr = el.querySelector(".mediavideo__video");
//     new Plyr(plyr, {
//       controls: ["play", "progress", "mute", "current-time"],
//       hideControls: true,
//       invertTime: false,
//       tooltips: { controls: false, seek: false }
//     });
//   });
// }; // plyrsInit();

// plyrsInit();

/*  ==========================================================================
  GENERAL - Share Icons
========================================================================== */
const socialLinksInit = function () {
  const socialLinks = document.querySelectorAll(".sociallink--popup");

  if (!socialLinks) {
    return;
  }

  socialLinks.forEach(socialLink =>
    socialLink.addEventListener("click", function (e) {
      e.preventDefault();
      const shareURL = this.getAttribute("href");
      var w = 550;
      var h = 550;
      var left = Number(screen.width / 2 - w / 2);
      var tops = Number(screen.height / 2 - h / 2);
      window.open(
        shareURL,
        "share-dialog",
        "resizable=no, width=" + w + ", height=" + h + ", top=" + tops + ", left=" + left + ""
      );
    })
  );
}; // socialLinksInit();
socialLinksInit();

/*  ==========================================================================
    GENERAL - Fancybox
  ========================================================================== */
const fancyboxInit = function () {
  const fancyboxOptions = {
    Hash: false, // Disabling Hash-based navigation, as it doesn't work on page reload
    Thumbs: false // Disable thumbnails
  };

  Fancybox.bind("[data-fancybox]", fancyboxOptions);
}; // fancyboxInit();

fancyboxInit();

/*  ==========================================================================
	GENERAL - Popup
		========================================================================== */

const pagePopup = document.querySelector("#popup");
const pagePopupBox = document.querySelector(".popup__box");
const pagePopupClose = document.querySelector(".popup__close");

const pagePopupInit = function (pagePopup) {
  if (!pagePopup || typeof Fancybox === "undefined") {
    return;
  }

  const popupBtn = document.querySelector("#popup__btn");
  if (!popupBtn) {
    return;
  }

  function showPopup() {
    Fancybox.show(
      [
        {
          src: "#popup",
          type: "inline"
        }
      ],
      {
        mainClass: "alert",
        dragToClose: false,
        closeButton: false,
        keyboard: false,
        trapFocus: false,
        placeFocusBack: false,
        click: false,
        backdropClick: false
      }
    );
    pagePopup.style.opacity = "1";
    pagePopup.style.visibility = "visible";
    pagePopup.style.height = "auto";
    pagePopupBox.style.opacity = "1";
    pagePopupBox.style.visibility = "visible";
    pagePopupBox.style.height = "auto";
    pagePopupClose.style.display = "flex";
  }

  setTimeout(showPopup, 1000);
};

pagePopupInit(pagePopup);

/*  ==========================================================================
		NAVIGATION - Anchor Links
		========================================================================== */

const postsAnchor = document.querySelector(".sidebar__anchor");

const postsAnchorInit = function () {
  if (!postsAnchor) {
    return;
  }

  const anchorLinks = postsAnchor.querySelectorAll(".sidebar__anchor__links .scrolltolink");

  anchorLinks.forEach(navLink =>
    navLink.addEventListener("click", function (e) {
      e.preventDefault();

      const targetSelector = this.getAttribute("href");
      const targetEl = document.querySelector(targetSelector);

      if (!targetEl) {
        return;
      }

      const headerOffset = document.querySelector(".siteheader").offsetHeight;
      const elementPosition = targetEl.getBoundingClientRect().top + window.pageYOffset;
      const offsetPosition = elementPosition - headerOffset;

      window.scrollTo({
        top: offsetPosition,
        behavior: "smooth"
      });
    })
  );
};

postsAnchorInit();

/*  ==========================================================================
		Partners & Resource Filters
		========================================================================== */

const filters = document.querySelector(".filters");

const filtersInit = function () {
  if (!filters) {
    return;
  }

  const regionSelectors = filters.querySelectorAll(".filter__dropdown--allowdropdown");

  regionSelectors.forEach(selector => {
    selector.addEventListener("click", e => {
      e.preventDefault();

      const regionDropdown = filters.querySelector(".filter__dropdown");
      const isOpen = regionDropdown.classList.contains("filter__dropdown--active");

      selector.classList.toggle("selector-active");
      regionDropdown.classList.toggle("filter__dropdown--active");

      if (!isOpen) {
        regionDropdown.style.height = regionDropdown.scrollHeight + "px";
      } else {
        regionDropdown.style.height = "0";
      }
    });
  });

  const handleResize = () => {
    const regionDropdown = filters.querySelector(".filter__dropdown");

    if (regionDropdown.classList.contains("filter__dropdown--active")) {
      // reset first so scrollHeight recalculates correctly
      regionDropdown.style.height = "auto";
      const newHeight = regionDropdown.scrollHeight;
      regionDropdown.style.height = newHeight + "px";
    }
  };

  window.addEventListener("resize", handleResize);

  const removeRegionButtons = filters.querySelectorAll(".remove-region");

  removeRegionButtons.forEach(button => {
    button.addEventListener("click", e => {
      e.preventDefault();
      const url = new URL(window.location.href);
      url.searchParams.delete("region");
      window.location.href = url.toString();
    });
  });

  const removeTopicButtons = filters.querySelectorAll(".remove-topic");

  removeTopicButtons.forEach(button => {
    button.addEventListener("click", e => {
      e.preventDefault();
      const url = new URL(window.location.href);
      url.searchParams.delete("topic");
      window.location.href = url.toString();
    });
  });

  const partnerSearchBoxes = filters.querySelectorAll(".filter__search");

  partnerSearchBoxes.forEach(searchBox => {
    const button = searchBox.querySelector(".filter__search-input");
    const submitButton = searchBox.querySelector(".filter__search-button");
    const partnerSearchInput = searchBox.querySelector(".filter__search-input input");

    if (!button) {
      return;
    }

    searchBox.addEventListener("click", e => {
      if (e.target.closest(".filter__search-button")) {
        return;
      }

      e.preventDefault();
      toggleSearch(searchBox, partnerSearchInput);
    });

    if (partnerSearchInput) {
      partnerSearchInput.addEventListener("click", e => {
        e.preventDefault();
        toggleSearch(searchBox, partnerSearchInput);
      });
    }

    if (submitButton) {
      submitButton.addEventListener("click", e => {
        e.preventDefault();

        const form = searchBox.closest("form");
        if (form) {
          form.submit();
        }
      });
    }
  });

  function toggleSearch(searchBox, partnerSearchInput) {
    const isOpen = searchBox.classList.contains("filter__search--active");

    searchBox.classList.toggle("filter__search--active");

    if (!isOpen) {
      partnerSearchInput.style.width = "94%";
      if (window.screen.width >= gridSizes.lg) {
        partnerSearchInput.style.width = "206px";
      }

      partnerSearchInput.removeAttribute("size");
    } else {
      if (window.screen.width >= gridSizes.lg) {
        partnerSearchInput.style.width = "0";
      }
      partnerSearchInput.setAttribute("size", "6");
    }
  }

  const removeSearchButtons = filters.querySelectorAll(".remove-search");

  removeSearchButtons.forEach(button => {
    button.addEventListener("click", e => {
      e.preventDefault();
      const url = new URL(window.location.href);
      url.searchParams.delete("search");
      window.location.href = url.toString();
    });
  });

  const mobileFilter = filters.querySelector(".mobile__filter-wrap .filter__btn");

  mobileFilter.addEventListener("click", e => {
    e.preventDefault();

    const mobileFilterWrap = mobileFilter.closest(".mobile__filter-wrap");
    const mobileFilters = mobileFilterWrap.querySelector(".mobile__filters");
    const isOpen = mobileFilters.classList.contains("mobile__filters--active");

    mobileFilterWrap.classList.toggle("selector-active");
    mobileFilters.classList.toggle("mobile__filters--active");

    if (!isOpen) {
      mobileFilters.style.height = mobileFilters.scrollHeight + "px";
    } else {
      mobileFilters.style.height = "0";
    }
  });
};

filtersInit();

/*  ==========================================================================
		Tools
		========================================================================== */

const tooliframe = document.querySelector(".tooliframe");

const toolIframeInit = function () {
  if (!tooliframe) {
    return;
  }

  window.addEventListener("message", function (event) {
    console.log(event.data.height);

    if (event.data.type === "IFRAME_HEIGHT") {
      tooliframe.style.height = event.data.height + "px";
    }
  });
};

toolIframeInit();

/*  ==========================================================================
    AJAX - AJAX load more / paging
    ========================================================================== */

const loadmoreBtn = document.querySelector(".paging__loadmore");
const loadmoreContainer = document.querySelector(".loadmore-container");

const loadmoreLoadPostsMultiplePages = function (pages) {
  if (pages && pages > 1) {
    //Stopping default scroll back to previous position
    history.scrollRestoration = "manual";

    const currentPage = new URL(window.location);

    //Creating an array on page numbers to map it
    var list = [];
    for (var i = 1; i < pages; i++) {
      list.push(i);
    }

    // Initialising the array of posts pages
    var postsHTML = [];

    const button = loadmoreBtn;
    const buttonText = button.innerHTML; // store current button text
    button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts

    // Array of ajax calls
    var allAJAX = list.map(function (page) {
      const data = {
        action: "loadmore",
        query: php_variables.posts, // that's how we get params from wp_localize_script() function
        page: page
      };
      //Updating the url to mtch the page number
      currentPage.searchParams.set("pagenum", page);
      return $.ajax({
        url: php_variables.ajax_url, // AJAX handler
        data: data,
        type: "POST",
        success: function (data) {
          postsHTML[page] = data;
        }
      });
    });

    // Waiting for all the ajax calls to be finished before proceeding
    Promise.all(allAJAX).then(function () {
      // Update current page variable
      php_variables.current_page = pages;

      button.innerHTML = buttonText; // set back to previous button text

      // Adding the new tiles to the dom
      list.map(page => {
        if (postsHTML[page]) {
          loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + postsHTML[page];
        }
      });

      // Updating the href for the loadmore button
      const nextPage = new URL(window.location);
      nextPage.searchParams.set("pagenum", parseInt(pages) + 1);
      button.href = nextPage;

      // if last page, remove the button..
      if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
        button.style.display = "none";
      }

      // Re-init lazy load
      lazyLoadInstance.update(); // reinit lazy load after clones
      // Re-init effects
      const effects = document.querySelectorAll(".effect");
      effectsInit(effects);

      // Scrolling the page to the last known position
      if (localStorage.getItem("scrollPosition")) {
        window.scroll({
          top: parseInt(localStorage.getItem("scrollPosition"), 10),
          behavior: "instant"
        });
      }
    });
  }
};

const loadmoreLoadPosts = function (e) {
  e.preventDefault(); // Preventing the a tag from redirecting to the page
  const button = this;
  const data = {
    action: "loadmore",
    query: php_variables.posts, // that's how we get params from wp_localize_script() function
    page: php_variables.current_page
  };
  let buttonText; // create variable to store button text

  // This AJAX triggers a PHP hook within functions-ajax.php called ajax_loadmore_handler
  $.ajax({
    url: php_variables.ajax_url, // AJAX handler
    data: data,
    type: "POST",
    beforeSend: function (xhr) {
      buttonText = button.textContent; // store current button text
      button.textContent = "Loading..."; // change the button text, to let the user know we are loading more posts
    },
    success: function (data) {
      if (data) {
        button.textContent = buttonText; // set back to previous button text
        loadmoreContainer.innerHTML = loadmoreContainer.innerHTML + data; // insert new posts to the loadmore-container, this should be the row that includes the posts

        php_variables.current_page++;

        // Only push state to set the last page number or if there is more pages to load
        const currentPage = new URL(window.location);

        if (parseInt(php_variables.current_page) <= parseInt(php_variables.max_page)) {
          currentPage.searchParams.set("pagenum", php_variables.current_page);
          history.pushState({}, "", currentPage);
        }

        //Updating the loadmore link
        const nextPage = new URL(window.location);
        nextPage.searchParams.set("pagenum", parseInt(php_variables.current_page) + 1);

        button.href = nextPage;

        // if last page, remove the button..
        if (parseInt(php_variables.current_page) === parseInt(php_variables.max_page)) {
          button.style.display = "none";
        }
        // Re-init links to make sure linklines on newly loaded content still work
        linksInit();
        // Re-init lazy load
        lazyLoadInstance.update(); // reinit lazy load after clones
        // Re-init effects
        const effects = document.querySelectorAll(".effect");
        effectsInit(effects);
      } else {
        button.style.display = "none"; // if no data, remove the button as well
      }
    }
  });
}; // loadmoreLoadPosts();

const loadmoreInit = function () {
  if (!loadmoreBtn) {
    return;
  }
  /** When adding fitering you will need to move this part into the filtering call */
  // Checking if the page paramenter is set
  const currentPage = new URL(window.location);
  let currentPageNum = currentPage.searchParams.get("pagenum");

  //If there is more than one page to load
  if (currentPageNum && currentPageNum > 1) {
    currentPageNum = currentPageNum > php_variables.max_page ? php_variables.max_page : currentPageNum;
    loadmoreLoadPostsMultiplePages(currentPageNum);
  }
  /** -end- */

  // Saving the scroll position before unload
  window.addEventListener("unload", function (e) {
    var scrollPosition = window.pageYOffset;
    localStorage.setItem("scrollPosition", scrollPosition);
  });

  loadmoreBtn.addEventListener("click", loadmoreLoadPosts);
}; // loadmoreInit();

loadmoreInit();

/*  ==========================================================================
    Scroll effects
    ========================================================================== */

const effects = document.querySelectorAll(".effect");

const effectsInit = function (effects) {
  if (!effects) {
    return;
  }

  effects.forEach(function (val) {
    const waypoints = new Waypoint({
      element: val,
      handler: function (direction) {
        if (direction === "down") {
          val.classList.add("effect--ready");
        } else {
          val.classList.remove("effect--ready");
        }
      },
      offset: "90%"
    });
  });
}; // effectsInit();
effectsInit(effects);

/*  ==========================================================================
    Pinned Scroll List
    ========================================================================== */

const pinnedScrollLists = document.querySelectorAll(".module--pinned-scroll-list.multiple");

const pinnedScrollListsInit = function (pinnedScrollLists) {
  if (!pinnedScrollLists) {
    return;
  }

  pinnedScrollLists.forEach(function (pinnedScrollList) {
    const pinnedLists = pinnedScrollList.querySelectorAll(".pinned-list--multiple");
    const imgs = pinnedScrollList.querySelectorAll(".pinned-img__img");

    imgs.forEach(img => img.classList.remove("active"));

    const first = pinnedScrollList.querySelector(".pinned-img__img--1");
    if (first) {
      first.classList.add("active");
    }

    const observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const swapClass = entry.target.dataset.swap;

            imgs.forEach(img => img.classList.remove("active"));
            pinnedScrollList.querySelector("." + swapClass).classList.add("active");
          }
        });
      },
      {
        root: null,
        threshold: 0.6
      }
    );

    pinnedLists.forEach(list => observer.observe(list));
  });
};

pinnedScrollListsInit(pinnedScrollLists);

/*  ==========================================================================
    GENERAL - Featured People 
    ========================================================================== */

const featuredPeople = document.querySelectorAll(".module--featured-people .featured__people-tabs");

const industryTabbedContent = function (featuredPeople) {
  if (!featuredPeople) {
    return;
  }

  featuredPeople.forEach(section => {
    const tabOptions = section.querySelectorAll(".tab__option");

    if (tabOptions.length <= 0) {
      return;
    }

    const container = section.querySelector(".featured__tabcontainer");

    let activeTab = section.querySelector(".featured__tab--active");
    let activeOption = section.querySelector(".tab__option--active");

    activeTab.classList.add("featured__tab--active");
    activeOption.classList.add("tab__option--active");

    container.style.height = activeTab.scrollHeight + "px";

    tabOptions.forEach(option => {
      option.addEventListener("click", e => {
        e.preventDefault();

        const targetTab = section.querySelector(`[data-id="tab-${option.dataset.value}"]`);

        if (targetTab === activeTab) {
          return;
        }

        const fromHeight = activeTab.scrollHeight;
        const toHeight = targetTab.scrollHeight;

        container.style.height = fromHeight + "px";

        activeTab.classList.remove("featured__tab--active");
        targetTab.classList.add("featured__tab--active");

        tabOptions.forEach(o => o.classList.remove("tab__option--active"));
        option.classList.add("tab__option--active");

        requestAnimationFrame(() => {
          container.style.height = toHeight + "px";
        });

        activeTab = targetTab;
      });
    });
  });
};

industryTabbedContent(featuredPeople);

/*  ==========================================================================
    Featured Titles
    ========================================================================== */
const featuredTitles = document.querySelectorAll(".featured-tiles--1 .tile-col");

const featuredTitlesInit = function (featuredTitles) {
  if (!featuredTitles) {
    return;
  }

  featuredTitles.forEach(function (el) {
    new Waypoint({
      element: el,
      handler: function (direction) {
        if (direction === "down") {
          el.classList.add("tile-col--ready");
        } else {
          el.classList.remove("tile-col--ready");
        }
      },
      offset: "90%"
    });

    new Waypoint({
      element: el,
      handler: function (direction) {
        if (direction === "down") {
          el.classList.remove("tile-col--ready");
        } else {
          el.classList.add("tile-col--ready");
        }
      },
      offset: "-50%"
    });
  });
};

featuredTitlesInit(featuredTitles);

/*  ==========================================================================
			Grid Carousel (Currently used on Featured Posts & Featured People)
			========================================================================== */

const gridCarousels = document.querySelectorAll(".row--carousel .owl-carousel");

const gridCarouselInit = function (gridCarousels) {
  if (gridCarousels.length <= 0) {
    return;
  }

  gridCarousels.forEach(elem => {
    const slides = elem.querySelectorAll(".col");
    if (!slides) {
      return;
    }

    const responsiveArray = carouselResponsiveArray(elem);

    // Optional data attribute settings
    const autoplay = elem.dataset.autoplay ? elem.dataset.autoplay : false;
    const autoplayTimeout = elem.dataset.autoplayTimeout ? elem.dataset.autoplayTimeout : 5000;
    const loop = elem.dataset.loop ? elem.dataset.loop : false;
    const nav = elem.dataset.nav ? elem.dataset.nav : false;
    const dots = elem.dataset.dots ? elem.dataset.dots : false;
    // Default for autoheight is "true", so to turn off you need to set the data-attribute to "disable"
    const autoHeight = elem.dataset.autoHeight && elem.dataset.autoHeight === "disable" ? false : true;

    var owlCarousel = $(elem).owlCarousel({
      autoplay: autoplay,
      autoplayTimeout: autoplayTimeout,
      loop: loop,
      nav: nav,
      dots: dots,
      items: 1,
      navText: ["<i class='fa-light fa-arrow-left'></i>", "<i class='fa-light fa-arrow-right'></i>"],
      responsive: responsiveArray,
      startPosition: 0,
      autoHeight: autoHeight,
      onInitialized: function () {
        lazyLoadInstance.update();
        Waypoint.refreshAll();
      }
    });

    // Safari iOS fix, causing a 1px height until a carousel change happened
    var adjustCarouselHeight = setInterval(function () {
      if (owlCarousel.height() > 1) {
        clearInterval(adjustCarouselHeight);
      }
      owlCarousel.trigger("refresh.owl.carousel", [100]);
    }, 300);

    $(elem).on("resized.owl.carousel", function (event) {
      // Refresh waypoints on resize with slight delay - bit of a hack but stop its breaking waypoint animations
      setTimeout(function () {
        Waypoint.refreshAll();
      }, 500);
    });
  });
}; // gridCarouselInit();
gridCarouselInit(gridCarousels);

/*  ==========================================================================
    Grid Carousel - Create responsive array 
    ========================================================================== */

function carouselResponsiveArray(elem) {
  let responsiveArray = {};
  const slides = elem.querySelectorAll(".col");
  const classes = slides[0].classList;

  classes.forEach((cl, index) => {
    if (cl.indexOf("col-") !== -1) {
      let className = cl;
      let classWidth = 0;
      let numItems = 4;
      className = cl.replace("col-", "");
      // get min width from col class
      const classGridsize = className.split("-")[0];
      // check this is a string not a number, this will remove up cols that dont have a grid size e.g. col-1-2
      if (isNaN(classGridsize)) {
        className = className.replace(classGridsize + "-", "");
        classWidth = gridSizes[classGridsize];
      } else {
        classWidth = 0;
      }
      // split rest of class into sections (this should now be something like '1-4')
      const otherClassParts = className.split("-");
      // divide second number (e.g 4) by first number (e.g 1) to get number of items
      if (otherClassParts[1]) {
        numItems = otherClassParts[1] / otherClassParts[0];
      } else {
        numItems = 1; // if there isn't a second number it must be a single grid
      }
      responsiveArray[classWidth] = {
        items: numItems
      };
    }
  });

  return responsiveArray;
} // carouselResponsiveArray();

/*  ==========================================================================
	NAVIGATION - mobnav
	========================================================================== */

const mobnav = document.querySelector(".mobnav");
const siteHeaderBd = document.querySelector(".siteheader__bd");
const mobnavToggle = document.querySelector(".mobnav-toggle");
const mobnavDropdowns = document.querySelectorAll(".dropdown");
const mobnavOpenclass = "mobnavopen";

const mobnavSetHeight = function () {
  const mobnavHeight = window.innerHeight - siteHeaderBd.getBoundingClientRect().height;
  mobnav.style.height = `${mobnavHeight}px`;
}; // mobnavSetHeight()

const mobnavInit = function () {
  // Open mobnav on click the toggle
  mobnavToggle.addEventListener("click", function (e) {
    e.preventDefault();
    if (!body.classList.contains(mobnavOpenclass)) {
      // IT'S NOT OPEN...
      body.classList.add(mobnavOpenclass);
    } else {
      // IT'S OPEN...
      body.classList.remove(mobnavOpenclass);
      mobnavBackTitle.classList.remove("mobnav__back--active");
      mobnavBackTrigger.classList.remove("mobnav__back--active");
      siteLogo.classList.remove("siteheader__logo--hide");
      mobnavBackTitle.textContent = "";

      mobnavDropdowns.forEach(function (mobnavDropdown) {
        mobnavDropdown.classList.remove("dropdown-active");
      });
    }
  });
}; // mobnavInit()
mobnavInit();

/*  ==========================================================================
      NAVIGATION - Platform Dropdown
      ========================================================================== */

const siteNav = document.querySelectorAll(".sitenav  .sitenav__item");
const siteNavInit = function () {
  if (!siteNav) {
    return;
  }

  let activeDropdown = null;
  let activeLink = null;

  function openDropdown(navId, linkEl) {
    const dropdown = document.getElementById(navId.trim());
    if (!dropdown) {
      return;
    }

    // Add class to the body
    document.body.classList.add("platformopen");

    if (activeDropdown && activeDropdown !== dropdown) {
      activeDropdown.style.height = 0;
      activeDropdown.classList.remove("platform__dropdown--open");
    }

    // Activate link
    if (activeLink && activeLink !== linkEl) {
      activeLink.classList.remove("sitenav__link--active");
    }
    linkEl.classList.add("sitenav__link--active");
    activeLink = linkEl;

    const content = dropdown.querySelector(".platform__dropdown-inner");
    const height = content.scrollHeight;

    dropdown.style.height = height + "px";
    dropdown.classList.add("platform__dropdown--open");

    activeDropdown = dropdown;
  }

  function closeDropdown() {
    if (activeDropdown) {
      activeDropdown.style.height = 0;
      document.body.classList.remove("platformopen");
      activeDropdown.classList.remove("platform__dropdown--open");
      activeDropdown = null;
    }

    if (activeLink) {
      activeLink.classList.remove("sitenav__link--active");
      activeLink = null;
    }
  }

  siteNav.forEach(function (item) {
    const navId = item.getAttribute("data-id");
    const link = item.querySelector(".sitenav__link");

    item.addEventListener("mouseenter", () => {
      if (item.classList.contains("sitenav__item--platform")) {
        openDropdown(navId, link);
      } else {
        closeDropdown();
      }
    });
  });

  document.querySelectorAll(".platform__dropdown").forEach(dropdown => {
    dropdown.addEventListener("mouseleave", closeDropdown);
  });
};
siteNavInit();

/*  ==========================================================================
      NAVIGATION - mobnav dropdowns
      ========================================================================== */

const mobnavLinks = document.querySelectorAll(".mobnav .sitenav__item--hasdropdown .sitenav__link--dropdowntrigger");

const sitenavDropdown = document.querySelector(".mobnav .sitenav__dropdown");
const siteLogo = document.querySelector(".siteheader__logo");
const mobnavBackTitle = document.querySelector(".mobnav__back--title");
const mobnavBackTrigger = document.querySelector(".mobnav__back--trigger");

const mobnavlinksInit = function () {
  if (!mobnavLinks) {
    return;
  }

  mobnavLinks.forEach(function (mobnavLink) {
    mobnavLink.addEventListener("click", function (e) {
      e.preventDefault();

      const navTarget = mobnavLink.getAttribute("data-nav-target");
      const nextPanel = sitenavDropdown.querySelector(`[data-nav-id="${navTarget}"]`);

      mobnavBackTitle.textContent = mobnavLink.textContent.trim();
      mobnavBackTitle.classList.add("mobnav__back--active");

      siteLogo.classList.add("siteheader__logo--hide");
      mobnavBackTrigger.classList.add("mobnav__back--active");
      nextPanel.classList.add("dropdown-active");

      const backButton = document.querySelector(".mobnav__back--trigger");

      backButton.addEventListener("click", function (e) {
        nextPanel.classList.remove("dropdown-active");
        mobnavBackTitle.classList.remove("mobnav__back--active");
        mobnavBackTrigger.classList.remove("mobnav__back--active");
        siteLogo.classList.remove("siteheader__logo--hide");
        mobnavBackTitle.textContent = "";
      });
    });
  });
}; // mobnavlinksInit();
mobnavlinksInit();

/*  ==========================================================================
	FORM - Trigger after Form Submission
	========================================================================== */

const triggerAfterSubmit = function () {
  jQuery(document).on("gform_confirmation_loaded", function (event, formId) {
    Waypoint.refreshAll();
  });
};

triggerAfterSubmit();

/*  ==========================================================================
	HUBSPOT - Gated Content
	========================================================================== */

const gatedContent = document.getElementById("gated-content");
const gatedContentInit = function () {
  if (!gatedContent) {
    return;
  }

  hbspt.forms.create({
    portalId: "8566416",
    formId: "51ee2a38-381d-4599-abde-09e28f671988",
    target: "#hubspot-form",
    onFormSubmitted: function () {
      gatedContent.classList.remove("on");
      setCookie("gatedcontent", "off", 99);
    }
  });

  document.addEventListener("DOMContentLoaded", function () {
    if (document.cookie.includes("gatedcontent")) {
      gatedContent.classList.remove("on");
    }
  });
};

gatedContentInit();

function setCookie(cname, cvalue, exdays) {
  const d = new Date();
  d.setTime(d.getTime() + exdays * 24 * 60 * 60 * 1000);
  let expires = "expires=" + d.toUTCString();
  document.cookie = cname + "=" + cvalue + ";" + expires + ";path=/";
}
